// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"5cc88c51","413":"934286df","963":"4e3391cc"}[chunkId] + ".chunk.js";
};